import { Box, Text, Tooltip } from "@mantine/core"
import { stripHtml } from "../../../../utils"


const CardTextArea = ({ item }: { item: any }) => {

  const title = item?.title 
  const text =  item?.text
  const excerpt =  item?.excerpt

  return (
    <Box mt={15} sx={{
   
    }}>
      {title &&
      <Tooltip label={title} multiline maw={400}>
        <Text fz={14} fw={600} lineClamp={1}  mb={14} lh={"18px"}>
          {title}
        </Text>
      </Tooltip>
      
      }

      {text &&
       <Box  py={8} px={12} bg='#F8F9FA' sx={{borderLeft: '2px solid rgba(92, 92, 235, 0.6)',}}>
         <Text fz={14} color="#212529" sx={{
           whiteSpace: "pre-line",
           lineHeight: "18px"
         }}>
           {
             item?.ml?.functionalitySummary ? (
               <div>
                 <b>Gap/Request: </b>
                 {stripHtml(item?.ml?.functionalitySummary)}
                 <br /><br />
                 <b>Underlying need: </b>
                 {stripHtml(item?.ml?.functionalityGap)}
               </div>
             ) : stripHtml(text)
           }        
         </Text>
         
       </Box>} 
      {excerpt && excerpt !=='' &&
      <Box  py={8} px={12} bg='#F8F9FA' sx={{borderLeft: '2px solid rgba(92, 92, 235, 0.6)'}} /* mt={2000} */>
        <Box fz={14} lh={"18px"}>
          <Text mb='5px' fw={600} style={{color:'black', fontSize:'14px' }}>Excerpt: </Text>  
          <Text color="#585C68" sx={{
            whiteSpace: "pre-line",
          }}>{stripHtml(excerpt)}</Text>
        </Box>
         
      </Box>}
     
    </Box>
  )
}

export default CardTextArea